import React from "react";
import {
  Box,
  Modal,
  Typography,
} from "@mui/material";
import { globalColors } from "../../../../../../../../../_metronic/_assets/sass/custom/globalColors";
import styled from "styled-components";
import { Container } from "@material-ui/core";

const Button = styled.button`
  position: relative;
  width: ${({ submitText }) => (submitText ? "200px" : "150px")};
  height: 48px;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;

  padding: 0;

  background: #fff;
  margin-right: 8px;
  border-radius: 4px;
  color: ${({ color }) => (color ? color : "#4D4C4D")};
  border: ${({ color }) =>
    color ? `1px solid ${color}` : "1px solid #4D4C4D"};

  border-radius: 4px;
  transition: filter 0.4s;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: ${({ variant }) =>
    variant === "cancel" ? "underline" : ""};
  }

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:disabled {
    background: ${globalColors.textColor3};
    cursor: not-allowed;
    border-color: ${({ color }) =>
    color ? globalColors.textColor3 : "#4D4C4D88"};
  }

  ${({ variant }) =>
    variant === "primary"
      ? `
    background: ${globalColors.primaryColor2};
    color: white;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 0px;
    `
      : variant === "cancel" &&
      `
      background: transparent;
      color: ${globalColors.primaryColor2};
      border-color: transparent
    `};
`;

export const RejectingDocumentModalInfo = (props) => {
  return (
    <>
      <Modal
        open={props.open}
        onClose={() => props.handleOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              borderRadius: 2,
              boxShadow: 24,
              width: 700,
              height: 321,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: 0,
            }}
          >
            <Typography variant="h5"
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                textAlign: "center",
              }}
            >Motivo da rejeição</Typography>
            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "left",
                alignItems: "left",
                width: "100%",
                height: "70%",
                color: "black",
              }}
              maxWidth="lg"
            >
            <Typography variant="h6"
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                textAlign: "left",
              }}
            >{props.observationReject}</Typography>
            </Container>
            <Container
              maxWidth="lg"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "30%",
              }}
            >
            <Button
              variant="primary"
              type="submit"
              color={globalColors.primaryColor2}
              onClick={
                () => {
                  props.handleOpen(false);
                }}
            >
              Confirmar
            </Button>
            </Container>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default RejectingDocumentModalInfo;
